import { useState } from "react";
import Win10Card from "../Win10Card";

export default function AfrondenCard({ werkbon, onAfronden, statusNotice = "" }) {

  const [bezig, setBezig] = useState(false);


  const handleAfronden = async () => {

    const ok = window.confirm(
      "Weet je zeker dat je deze werkbon wilt afronden?"
    );

    if (!ok) return;

    try {
      setBezig(true);
      await onAfronden();
    } finally {
      setBezig(false);
    }
  };


  const isKlaar =
    werkbon?.status === "in_uitvoering" ||
    werkbon?.status === "actief";
  const missingItems = getCompletionMissingItems(werkbon);
  const signatureRequired = werkbon?.completionFlow?.signatureRequired === true;
  const signatureCaptured = werkbon?.completionFlow?.signatureCaptured === true;
  const showIncomplete = missingItems.length > 0 || (signatureRequired && !signatureCaptured);


  return (
    <Win10Card title="Afrondstatus">

      <p className="mb-3 text-sm text-gray-700">
        Controle en aanvulling van afronding voor dossierkwaliteit.
      </p>


      {showIncomplete ? (
        <div className="mb-3 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
          <p className="font-semibold">Afronding nog niet compleet</p>
          <ul className="mt-1 list-disc space-y-0.5 pl-4">
            {missingItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
            {signatureRequired && !signatureCaptured ? <li>Klant-handtekening</li> : null}
          </ul>
        </div>
      ) : (
        <p className="mb-3 rounded border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-800">
          Afronding compleet genoeg om gereed te melden.
        </p>
      )}

      {!isKlaar && (
        <p className="text-xs text-gray-600 mb-2">
          Gereedmelden is beschikbaar zodra de werkbon in uitvoering staat.
        </p>
      )}

      {statusNotice ? (
        <div className="mb-3 rounded border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-700">
          <p className="font-semibold">Controle-signaal</p>
          <p className="mt-1">{statusNotice}</p>
        </div>
      ) : null}


      <button
        onClick={handleAfronden}
        disabled={!isKlaar || bezig}
        className={`
          w-full px-4 py-3 rounded text-white
          ${isKlaar
            ? "bg-green-600 hover:bg-green-700"
            : "bg-gray-400 cursor-not-allowed"
          }
        `}
      >

        {bezig
          ? "Bezig met afronden..."
          : "Gereed melden"
        }

      </button>

    </Win10Card>
  );
}

function getCompletionMissingItems(werkbon) {
  const missingKeys = Array.isArray(werkbon?.completionState?.missing)
    ? werkbon.completionState.missing
    : [];
  const items = [];

  for (const key of missingKeys) {
    if (key === "executionLog") items.push("Daglog/uitvoeringstekst");
    if (key === "hours") items.push("Tijdregistratie");
    if (key === "materials") items.push("Materiaalregistratie");
    if (key === "evidence") items.push("Foto of bijlage");
  }

  return Array.from(new Set(items));
}
